import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import App from './App';
import store from './store/store';
import 'font-awesome/css/font-awesome.min.css';

// import './utils/i18n';
import './index.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import Layout from './constants/layout/Layout';


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    {/* <BrowserRouter basename='/nest-build'> for build and deploy*/} 
    <BrowserRouter>
      {/* <App /> */}
      <Layout/>
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
